module.exports = __webpack_public_path__ + "static/media/shequluntan.d2265a1d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/svg/shequluntan.svg
// module id = 636
// module chunks = 0